
const Button = {
    view: ({attrs: {cssClasses, iconClass, text, onclick}}) =>
        <button class={`btn ${cssClasses}`} type="submit" onclick={(e) => onclick(e)}>
            <i class={iconClass}></i><span class="btn-text">{text}</span>
        </button>
};

export default Button;
